// import anime from 'animejs/lib/anime.min.js';
import Swiper from 'swiper/swiper-bundle.min.js';

export default {
  init() {
  },
  finalize() {

    new Swiper('#services-icons .swiper-container', {
      effect: 'flip',
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 2500,
      },
    });

    // @todo
    // $('.cloud-grid').isotope({
    //   itemSelector: '.grid-item',
    //   masonry: {
    //     columnWidth: 0,
    //   },
    // });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/services.js